import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => (
    <footer className="bg-slate-900 text-slate-400 py-6 mt-auto border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-gradient-to-br from-brand-600 to-indigo-600 rounded-lg text-white flex items-center justify-center font-bold text-xs">N</div>
                <span className="font-semibold text-slate-200">Nestly Suite</span>
            </div>
            <div className="flex gap-6">
                <a href="https://www.nestlysuite.com" className="hover:text-white transition-colors">Home</a>
                <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
                <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
                <Link to="/admin-login" className="hover:text-white transition-colors">Admin</Link>
            </div>
            <p>© {new Date().getFullYear()} Nestly Suite Inc.</p>
        </div>
    </footer>
);
